import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function VapingFrequencyPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.vapingFrequency.heading')}
      buttons={[
        {
          text: t('pages.onboarding.vapingFrequency.options.1-5-sessions'),
          value: '1-5-sessions',
        },
        {
          text: t('pages.onboarding.vapingFrequency.options.6-10-sessions'),
          value: '6-10-sessions',
        },
        {
          text: t('pages.onboarding.vapingFrequency.options.11-20-sessions'),
          value: '11-20-sessions',
        },
        {
          text: t('pages.onboarding.vapingFrequency.options.21-40-sessions'),
          value: '21-40-sessions',
        },
        {
          text: t(
            'pages.onboarding.vapingFrequency.options.more-than-40-sessions',
          ),
          value: 'more-than-40-sessions',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
